export default __webpack_public_path__ + "static/media/spacecowboy.0a8c3e79.gif";